module.exports = "<div [id]=\"chartDiv\" [ngStyle]=\"_style\" ></div>"